
const Facebook = () => {

    return (
        <div className="fb-page" data-href="https://www.facebook.com/clubvueloupm" data-tabs="timeline" data-width="" data-height="" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
            <blockquote cite="https://www.facebook.com/clubvueloupm" className="fb-xfbml-parse-ignore">
                <a href="https://www.facebook.com/clubvueloupm">Club de Vuelo UPM</a>
            </blockquote>
        </div>
    )
}

export default Facebook